
import { Injectable } from '@angular/core';
import { CommonConstants } from '../utilities/commonConstants';

@Injectable({
  providedIn: 'root'
})
export class VehicleRegistrationService {

  constructor() { }

  //Customer Name ErrMsg validation methods
  public validateCustomerName(customernameName: string, isValidate: boolean) {
    const splitedCustomerName = customernameName.trim().split(' ');
    if (!customernameName) {
      return CommonConstants.LABELPLACEHOLDERS.errorMESG.customerNameErrMsg;
    } else if (splitedCustomerName.length === 1 && customernameName.includes(' ') && isValidate) {
      return CommonConstants.LABELPLACEHOLDERS.errorMESG.lastNameErrMsg;
      // return '';
    } else if (splitedCustomerName.length === 1 && isValidate) {
      return CommonConstants.LABELPLACEHOLDERS.errorMESG.lastNameErrMsg;
      // return '';
    } else {
      return '';
    }
  }

  public customerNameGetValue(fieldName: string, customernameName: string)  {
    console.log("fieldName value", fieldName, customernameName);
    if (fieldName == 'firstname') {
      return customernameName[0];
    } else if (fieldName == 'middleName') {
      return customernameName.length === 3 ? customernameName[1] : '';
    } else if (fieldName == 'lastName') {
      return customernameName.length === 2 ? customernameName[1] : customernameName[2];
    }
  }
}